/**
 * Stable CSS class names for E2E — Customer LCW Money (wallet).
 */
export const CLM = {
    page: 'customer-lcw-money-page',
    toolbarRow: 'customer-lcw-money-page__toolbar-row',
    fieldAvailableBalance: 'customer-lcw-money-field--available-balance',
    inputButtonPayMoneyOrder: 'customer-lcw-money-input--button-pay-money-order',
    transferDisabledInfo: 'customer-lcw-money-field--transfer-disabled-info',
    datagrid: 'customer-lcw-money-page__datagrid',
    fieldChipAmount: 'customer-lcw-money-field--chip-amount',
} as const;

export const clmCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
